import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ICreatorCampaignExport } from '@pages/campaigns/campaigns.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CreatorCampaignExportService {
  private readonly http = inject(HttpClient);

  public getCreatorCampaignExport(id: string): Observable<ICreatorCampaignExport> {
    return this.http.get<ICreatorCampaignExport>(`/creator-campaign-exports/${id}`);
  }

  public createCreatorCampaignExport(campaignId: string, creatorId: string): Observable<ICreatorCampaignExport> {
    return this.http.post<ICreatorCampaignExport>(`/creator-campaign-exports`, { campaignId, creatorId });
  }

  public updateCreatorCampaignExport(id: string, isActive: boolean): Observable<ICreatorCampaignExport> {
    return this.http.put<ICreatorCampaignExport>(`/creator-campaign-exports/${id}`, { isActive });
  }
}
